import gql from 'graphql-tag'
import api from './apiClient'

export default {
  sendMail: (to, account, template, subject, content) =>
    api
      .send({
        query: gql`
          mutation SEND_MAIL($account: String!, $template: Template!, $to: String!, $subject: String!, $content: Content!) {
            Mailer {
              send(account: $account, template: $template, to: $to, subject: $subject, content: $content)
            }
          }
        `,
        variables: {
          to,
          account,
          template,
          subject,
          content
        }
      })
      .then(result => result.data.data.Mailer.send)
}
